import { gql } from 'graphql-request';

const OtherServicesFragment = gql`
  fragment OtherServices on OtherServicesBlock {
    title
    categories {
      ... on CategoryChooserBlock {
        name
        id
        services(hostname: $hostname) {
          id
          title
          slug
          url
        }
      }
    }
  }
`;

export default OtherServicesFragment;
